import Vue from 'vue'
import {
	Button,
	Table,
	TableColumn,
	Select,
	Tooltip,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxGroup,
	Option,
	Link,
	DatePicker,
	Input,
	Tree,
	Slider,
	Icon,
	Row,
	Col,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Container,
	Header,
	Aside,
	Main,
	Footer,
	Card,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Dialog,
	Pagination,
	Tabs,
	TabPane,
	Loading,
	Rate,
	MessageBox,
	Message,
	Notification,
	Alert,
} from 'element-ui';

Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Tooltip)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Option)
Vue.use(Link)
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Tree)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Card)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Dialog)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Rate)
Vue.use(Alert)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
